var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockFilLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "87px",
    viewBox: "0 0 77 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Lock_Fil_Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Lock_Fil_Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lock-File",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.1875 L0,77.8125 C0,80.665625 2.34642857,83 5.21428571,83 L67.7857143,83 C70.6535714,83 73,80.665625 73,77.8125 L73,20.75 L52.1428571,0 L5.21428571,0 C2.34642857,0 0,2.334375 0,5.1875 Z",
    id: "Document",
    stroke: "#007AFF",
    strokeWidth: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.397828,56.5 L44.3251974,56.5 L39.9519791,43.5875615 L41.2471642,43.0495274 C44.4341474,41.7256194 46.5,38.8425904 46.5,35.6436108 C46.5,31.1758377 42.497728,27.5 37.5000414,27.5 C32.5022832,27.5 28.5,31.1758279 28.5,35.6436108 C28.5,38.7628431 30.463503,41.585166 33.5293475,42.9529062 L34.7753718,43.5087848 L30.397828,56.5 Z",
    id: "Fill-5",
    stroke: "#0082FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shading",
    opacity: 0.149,
    transform: "translate(14.000000, 0.000000)",
    fill: "#007AFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1304348,0 L39.1304348,20.6153846 L60,20.6153846 L39.1304348,0 L39.1304348,0 Z M28.6956522,15.4615385 L0,15.4615385 L0,20.6153846 L28.6956522,20.6153846 L28.6956522,15.4615385 L28.6956522,15.4615385 Z M0,36.0769231 L49.5652174,36.0769231 L49.5652174,30.9230769 L0,30.9230769 L0,36.0769231 L0,36.0769231 Z M0,51.5384615 L49.5652174,51.5384615 L49.5652174,46.3846154 L0,46.3846154 L0,51.5384615 L0,51.5384615 Z M0,67 L39.1304348,67 L39.1304348,61.8461538 L0,61.8461538 L0,67 L0,67 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockFilLarge);
export default __webpack_public_path__ + "static/media/icon-lock-fil-large.025b6133b6ac88d0806e01d7177b351b.svg";
export { ForwardRef as ReactComponent };